import { render, staticRenderFns } from "./PropertyRegisterForm.vue?vue&type=template&id=60cd3928&"
import script from "./PropertyRegisterForm.vue?vue&type=script&lang=js&"
export * from "./PropertyRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRegisterForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports